import { render, staticRenderFns } from "./userIntegral.vue?vue&type=template&id=72a8f8b0"
import script from "./userIntegral.vue?vue&type=script&lang=js"
export * from "./userIntegral.vue?vue&type=script&lang=js"
import style0 from "./userIntegral.vue?vue&type=style&index=0&id=72a8f8b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports